export default __webpack_public_path__ + "2726e6883b8d2f0be8aca0b85b29f961.png";